import React from 'react';
import { Button, CloseButton, Form, Modal, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useOrdenOperations from '../hooks/useOrdenOperations';
import useOrdenComentarios from '../hooks/useOrdenComentarios';
import useOrdenNotificaciones from '../hooks/useOrdenNotificaciones';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const OrdenModalCancelar = ({
    showCancelarOrdenModal,
    setShowCancelarOrdenModal,
    motivoCancelacionOrden,
    setMotivoCancelacionOrden,
    orden,
    onOrdenCancelada
}) => {
    const { cancelarOrden, loadingEdit } = useOrdenOperations();
    const { guardarComentario } = useOrdenComentarios();
    const { crearObjAction, guardarNotificacion } = useOrdenNotificaciones();
    const { nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const handleCancelarOrden = async () => {
        await cancelarOrden(
            orden.idOrden,
            (mensaje) => {
                // Success
                guardarComentario(
                    orden.idOrden,
                    `<b class='badge badge-soft-danger'><strong>${nombreCompleto}</strong> canceló la orden... </b> Motivo: <b>${motivoCancelacionOrden}</b>`,
                    2,
                    orden,
                    () => { },
                    (error) => {
                        showErrorToast(error);
                        
                    }
                );

                // Enviar notificación
                const objToActionString = crearObjAction(2, "/ordenes/detalle/" + orden.idOrden, '', '');
                const jsonData = JSON.stringify({ idOrden: orden.idOrden });

                guardarNotificacion(
                    "Orden cancelada",
                    `<strong>${nombreCompleto}</strong> canceló la orden <strong>#${orden.idOrden}</strong>`,
                    0,
                    objToActionString,
                    8,
                    jsonData,
                    () => { },
                    (error) => {
                        showErrorToast(error);
                        
                    }
                );

                setShowCancelarOrdenModal(false);
                setMotivoCancelacionOrden("");
                showSuccessToast(mensaje);

                // Callback para recargar datos
                onOrdenCancelada?.();
            },
            (error) => {
                // Error
                showErrorToast(error);
                
            }
        );
    };

    return (
        <Modal
            show={showCancelarOrdenModal}
            onHide={() => { setShowCancelarOrdenModal(false); setMotivoCancelacionOrden(''); }}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">&iquest;C&uacute;al es el motivo para cancelar esta orden ?</Modal.Title>
                <CloseButton
                    className="btn btn-circle btn-sm transition-base p-0"
                    onClick={() => { setShowCancelarOrdenModal(false); setMotivoCancelacionOrden(''); }}
                />
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={(event) => { setMotivoCancelacionOrden(event.target.value); }}
                        value={motivoCancelacionOrden}
                        onKeyDown={
                            (e) => {
                                if (e.key === 'Enter')
                                    handleCancelarOrden();
                            }
                        }
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={() => { setShowCancelarOrdenModal(false); setMotivoCancelacionOrden(''); }}>Regresar</Button>

                {
                    !loadingEdit ?
                        <Button variant='success' onClick={handleCancelarOrden}>Guardar Motivo</Button>
                        :
                        <>
                            <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    );
};

OrdenModalCancelar.propTypes = {
    showCancelarOrdenModal: PropTypes.bool.isRequired,
    setShowCancelarOrdenModal: PropTypes.func.isRequired,
    motivoCancelacionOrden: PropTypes.string.isRequired,
    setMotivoCancelacionOrden: PropTypes.func.isRequired,
    orden: PropTypes.object.isRequired,
    onOrdenCancelada: PropTypes.func
};

export default OrdenModalCancelar;